import 'css-chunk:src/cms/skinnyBanner/skinnyBanner.module.scss';export default {
  "heading-xxl": "skinnyBanner-module__heading-xxl___kHhkS",
  "wrapper": "skinnyBanner-module__wrapper___a0AFj",
  "heading-xl": "skinnyBanner-module__heading-xl___lnr50",
  "heading-lg": "skinnyBanner-module__heading-lg___asfXY",
  "heading-md": "skinnyBanner-module__heading-md___n14-q",
  "heading-sm": "skinnyBanner-module__heading-sm___jSXKS",
  "heading-xs": "skinnyBanner-module__heading-xs___Fk1-U",
  "body-one": "skinnyBanner-module__body-one___--sjO",
  "body-two": "skinnyBanner-module__body-two___vh6--",
  "body-three": "skinnyBanner-module__body-three___XU-PB",
  "body-four": "skinnyBanner-module__body-four___u7qIC",
  "overline-one": "skinnyBanner-module__overline-one___9ZpmH",
  "overline-two": "skinnyBanner-module__overline-two___WN3KI",
  "overline-three": "skinnyBanner-module__overline-three___J-Lt5",
  "strong": "skinnyBanner-module__strong___ygFwd",
  "em": "skinnyBanner-module__em___Wy2XZ",
  "figcaption": "skinnyBanner-module__figcaption___Bvq3i",
  "no-margin": "skinnyBanner-module__no-margin___aD63C",
  "skinnyBannerWrapper": "skinnyBanner-module__skinnyBannerWrapper___zGqvn",
  "skinnyBannerContainer": "skinnyBanner-module__skinnyBannerContainer___qkEN6",
  "skinnyBannerTextContainer": "skinnyBanner-module__skinnyBannerTextContainer___l3OSE",
  "skinnyBannerPartnerContainer": "skinnyBanner-module__skinnyBannerPartnerContainer___N71rY",
  "skinnyBannerMediaContainer": "skinnyBanner-module__skinnyBannerMediaContainer___ysuu1",
  "skinnyBannerButtonContainer": "skinnyBanner-module__skinnyBannerButtonContainer___CLMAX"
};